import { t } from "@lingui/macro";
import { useEffect, useState } from "react";

import { Input } from "@whoosh/design-system/src/components/controls/Input";
import { SearchIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { useDebounce } from "@whoosh/utilities/src/hooks";

export const MemberModalSearchBar = ({
  value,
  onChange,
  isOpen,
}: {
  value?: string;
  onChange: (value: string) => void;
  isOpen?: boolean;
}) => {
  const [searchVal, setSearchVal] = useState(value ?? "");

  const debouncedOnChange = useDebounce(() => {
    onChange(searchVal);
  }, 300);

  useEffect(() => {
    if (!isOpen) {
      setSearchVal("");
    }
  }, [isOpen]);

  return (
    <Input
      testID="member-modal-search-input"
      leftIcon={<SearchIcon />}
      name={"search"}
      value={searchVal}
      placeholder={t`Search Members`}
      onChange={(val) => {
        if (typeof val !== "number") {
          setSearchVal(val);
          debouncedOnChange();
        }
      }}
    />
  );
};
